import { EmendaParlamentar, HistoricoEmendaItem, Usuario } from 'eddydata-lib';
import { BaseResourceModel } from '../../models/base-resource.model';

export class HistoricoEmenda extends BaseResourceModel {
  constructor(
    public id?: number,
    public data_cadastro?: Date,
    public emenda?: EmendaParlamentar,
    public usuario?: Usuario,
    public justificativa?: string,
    public itens?: HistoricoEmendaItem[],
  ) {
    super();
  }

  static converteJson(json: any): HistoricoEmenda {
    return Object.assign(new HistoricoEmenda(), json);
  }
}
